import styled from 'styled-components';
import { smallMediaQuery, mediumMediaQuery  } from '../../common/utilities/sizeHelpers';

/*
Hack to get rid of the top and bottom background image that is baked into the default page template
*/
export const RemoveBackgroundAddMenu = styled.div`
    border-top: 1px solid #d2d6d9;
    margin-top: -39px;
    background-color: #ffff;   
    height: 100%;
    margin-bottom: -40px;
`;

export const Title = styled.div`
    font-family: Source Sans Pro, Sans Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    text-transform: uppercase;
    color: #333333;
    margin-top: 24px;
    margin-bottom: 24px;

    @media ${smallMediaQuery} {
        text-align: center;
    }
`;

export const TitleImage = styled.img`
    max-height: 310px;
    width: 1106px;

    @media ${mediumMediaQuery} {
        width:773px;
    }

    @media ${smallMediaQuery} {
        width: 240px;
    }
`;

export const PartnerImage = styled.img`

    @media ${smallMediaQuery} {
        width: 240px;
    }
`;

export const PartnerText = styled.div`
    order: 2;
    flex-grow: 2;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    padding-left: 33px;
    margin-right: 50px;
    margin-bottom: 10px;
    color: #555555;

    @media ${smallMediaQuery} {
        padding-top: 16px;
        padding-left: 0px;
        width: 240px;
        font-size: 15px;
    }
`;

export const Container = styled.div`
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    width: 90%;
    margin: 0 auto;
    background-color: white;
    flex-direction: column;
    gap: 10px;
`;

export const PartnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;

    @media ${smallMediaQuery} {
        width: 288px;
        flex-direction: column;
    }
`;

export const PartnerImageDiv = styled.div`
    order: 1;
    @media ${smallMediaQuery} {
        width: 288px;
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;

    @media ${smallMediaQuery} {
        text-align: center;
    }
`;

export const ContainerRow = styled.div`
    margin: 0 auto;
    width: 1106px;

    @media ${mediumMediaQuery} {
        width:773px;
    }
    @media ${smallMediaQuery} {
        width: 240px;
    }
`;

export const PartnerParagraph = styled.p`
    font-family: Source Sans Pro;
    padding-top: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    align-items: center;
    color: #555555;

    @media ${smallMediaQuery} {
        padding-top: 16px;
        font-size:15px;
    }
`;
